import React from "react";
import { SERVICES } from "../../../data/products";
import SectionHeader from "../../common/SectionHeader/SectionHeader";
import AnimatedSection from "../../common/AnimatedSection/AnimatedSection";
import Card, { CardBody } from "../../ui/Card/Card";
import "./ServicesSection.css";
import { useLanguage } from "../../../context/LanguageContext";

export const ServicesSection: React.FC = () => {
  const { t } = useLanguage();
  return (
    <section id="services" className="services">
      <div className="container">
        <AnimatedSection animation="fadeInUp" delay={0.2}>
          <SectionHeader
            subtitle={t('services.subtitle')}
            title={t('services.title')}
            description={t('services.desc')}
          />
        </AnimatedSection>

        <AnimatedSection animation="fadeInUp" delay={0.4} className="animated-section--staggered">
          <div className="services__grid">
            {SERVICES.map((service, index) => (
              <div key={index} className="animated-section__item">
                <Card
                  variant="default"
                  hover
                  className="services__card"
                >
                  <CardBody>
                    <div className="services__icon">
                      <i className={service.icon}></i>
                    </div>
                    <h3 className="services__title">{t(`services.items.${service.id}.title`)}</h3>
                    <p className="services__description">{t(`services.items.${service.id}.desc`)}</p>
                  </CardBody>
                </Card>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default ServicesSection;
